/* ============================================================
   CATEGORIES SLIDER — vanilla JS, no dependencies
   File: assets/categories-slider.js
   ============================================================ */

(function () {
  function init(section) {
    const track = section.querySelector('[data-cats-track]');
    const cards = Array.from(section.querySelectorAll('[data-cats-card]'));
    const prev  = section.querySelector('[data-cats-prev]');
    const next  = section.querySelector('[data-cats-next]');
    const dotsContainer = section.querySelector('[data-cats-dots]');
    if (!track || cards.length === 0) return;

    const cardsPerView = () => {
      const w = window.innerWidth;
      if (w <= 640) return 1;
      if (w <= 1024) return 2;
      const sec = section.dataset.visibleDesktop;
      return sec ? parseInt(sec, 10) : 3;
    };

    const totalPages = () => Math.max(1, cards.length - cardsPerView() + 1);

    // Build dots
    function buildDots() {
      dotsContainer.innerHTML = '';
      const pages = totalPages();
      for (let i = 0; i < pages; i++) {
        const b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Seite ' + (i + 1));
        b.addEventListener('click', () => scrollToIndex(i));
        dotsContainer.appendChild(b);
      }
    }

    function update() {
      const cardWidth = cards[0]?.offsetWidth || 0;
      const gap = parseFloat(getComputedStyle(track).gap) || 0;
      const slideSize = cardWidth + gap;
      const idx = Math.round(track.scrollLeft / slideSize);
      const pages = totalPages();
      Array.from(dotsContainer.children).forEach((dot, i) => {
        dot.setAttribute('data-active', i === Math.min(idx, pages - 1) ? 'true' : 'false');
      });
      // Hide arrows + dots entirely when there's nothing to navigate to
      const navNeeded = cards.length > cardsPerView();
      if (prev) prev.style.setProperty('display', navNeeded ? 'flex' : 'none', 'important');
      if (next) next.style.setProperty('display', navNeeded ? 'flex' : 'none', 'important');
      dotsContainer.style.setProperty('display', navNeeded ? 'flex' : 'none', 'important');
      if (prev) prev.toggleAttribute('disabled', track.scrollLeft <= 4);
      if (next) next.toggleAttribute('disabled', track.scrollLeft + track.clientWidth >= track.scrollWidth - 4);
    }

    function scrollToIndex(i) {
      const cardWidth = cards[0]?.offsetWidth || 0;
      const gap = parseFloat(getComputedStyle(track).gap) || 0;
      track.scrollTo({ left: i * (cardWidth + gap), behavior: 'smooth' });
    }

    function step(dir) {
      const cardWidth = cards[0]?.offsetWidth || 0;
      const gap = parseFloat(getComputedStyle(track).gap) || 0;
      track.scrollBy({ left: dir * (cardWidth + gap), behavior: 'smooth' });
    }

    if (prev) prev.addEventListener('click', () => step(-1));
    if (next) next.addEventListener('click', () => step(1));
    track.addEventListener('scroll', () => requestAnimationFrame(update), { passive: true });
    window.addEventListener('resize', () => { buildDots(); update(); });

    buildDots();
    update();
  }

  function initAll() {
    document.querySelectorAll('.cats-section').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (e) => {
    const sec = e.target.querySelector('.cats-section');
    if (sec) init(sec);
  });
})();
